import React from 'react';

interface Props {
}

interface State {
}

export default class InvalidData extends React.PureComponent<Props, State> {
  constructor(props) {
    super(props);
  }

  render(): React.ReactNode {
    return (
      <div style={{height: '250px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <span className="text-center">Some problems with loading the data !!!</span>
      </div>
    );
  }
}
